import React, { useRef } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const Benefits = () => {
  // Create refs for animation targets
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const paragraphRef = useRef(null);
  const firstRowRef = useRef(null);
  const secondRowRef = useRef(null);
  const thirdRowRef = useRef(null);
  
  // Use our custom animation hooks
  useScrollAnimation({
    type: "fade",
    scope: sectionRef,
    trigger: "top 80%",
    duration: 0.8,
    from: { y: 40, opacity: 0 },
    to: { y: 0, opacity: 1 },
    ease: "power3.out"
  });
  
  // Staggered animation for first row of benefit cards
  useScrollAnimation({
    type: "stagger",
    scope: firstRowRef,
    trigger: "top 70%",
    stagger: 0.15,
    duration: 0.7,
    from: { y: 30, opacity: 0 },
    to: { y: 0, opacity: 1 },
    ease: "power2.out"
  });
  
  // Staggered animation for second row of benefit cards
  useScrollAnimation({
    type: "stagger",
    scope: secondRowRef,
    trigger: "top 70%",
    stagger: 0.15,
    duration: 0.7,
    from: { y: 30, opacity: 0 },
    to: { y: 0, opacity: 1 },
    ease: "power2.out"
  });
  
  // Staggered animation for third row of benefit cards
  useScrollAnimation({
    type: "stagger",
    scope: thirdRowRef,
    trigger: "top 70%",
    stagger: 0.15,
    duration: 0.7,
    from: { y: 30, opacity: 0 },
    to: { y: 0, opacity: 1 },
    ease: "power2.out"
  });
  const benefitsList = [
    {
      id: 1,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
        <g clipPath="url(#clip0_54_20044)">
        <path fillRule="evenodd" clipRule="evenodd" d="M21.7773 4.37296H13.9699V2.81147C13.9699 2.38028 13.6204 2.03073 13.1892 2.03073C12.758 2.03073 12.4084 2.38028 12.4084 2.81147V4.37296H4.60098C3.7386 4.37296 3.0395 5.07206 3.0395 5.93444V17.6456C3.0395 18.508 3.7386 19.2071 4.60098 19.2071H8.44224L6.33326 21.8421C6.06376 22.179 6.11838 22.6705 6.45525 22.94C6.79212 23.2095 7.28367 23.1549 7.55317 22.818L10.4409 19.2071H15.9374L18.8252 22.818C19.0946 23.1549 19.5862 23.2095 19.9231 22.94C20.2599 22.6705 20.3146 22.179 20.0451 21.8421L17.9361 19.2071H21.7773C22.6397 19.2071 23.3388 18.508 23.3388 17.6456V5.93444C23.3388 5.07206 22.6397 4.37296 21.7773 4.37296ZM21.7773 17.6456H4.60098V5.93444H21.7773V17.6456ZM10.8469 12.1804V14.5226C10.8469 14.9538 10.4974 15.3034 10.0662 15.3034C9.63499 15.3034 9.28544 14.9538 9.28544 14.5226V12.1804C9.28544 11.7492 9.63499 11.3996 10.0662 11.3996C10.4974 11.3996 10.8469 11.7492 10.8469 12.1804ZM13.9699 10.6189V14.5226C13.9699 14.9538 13.6204 15.3034 13.1892 15.3034C12.758 15.3034 12.4084 14.9538 12.4084 14.5226V10.6189C12.4084 10.1877 12.758 9.83816 13.1892 9.83816C13.6204 9.83816 13.9699 10.1877 13.9699 10.6189ZM17.0929 9.05742V14.5226C17.0929 14.9538 16.7433 15.3034 16.3121 15.3034C15.8809 15.3034 15.5314 14.9538 15.5314 14.5226V9.05742C15.5314 8.62622 15.8809 8.27667 16.3121 8.27667C16.7433 8.27667 17.0929 8.62622 17.0929 9.05742Z" fill="#ABABAB"/>
        </g>
        <defs>
        <clipPath id="clip0_54_20044">
        <rect width="24.9838" height="24.9838" fill="white" transform="translate(0.697266 0.469238)"/>
        </clipPath>
        </defs>
        </svg>
        ),
      title: "Competitive Salary",
    },
    {
      id: 2,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
        <g clipPath="url(#clip0_54_20051)">
        <path fillRule="evenodd" clipRule="evenodd" d="M12.14 15.7669C14.2885 14.3365 15.2471 11.6681 14.4999 9.19758C13.7528 6.72704 11.4761 5.03707 8.89507 5.03707C6.31402 5.03707 4.03736 6.72704 3.2902 9.19758C2.54305 11.6681 3.50162 14.3365 5.65011 15.7669C3.75728 16.4645 2.14077 17.7554 1.04177 19.4471C0.884573 19.6807 0.865369 19.9809 0.991512 20.2327C1.11766 20.4844 1.3696 20.6488 1.65085 20.6627C1.93209 20.6767 2.19907 20.5381 2.34951 20.3C3.7898 18.0848 6.25279 16.7484 8.89507 16.7484C11.5373 16.7484 14.0003 18.0848 15.4406 20.3C15.6789 20.6542 16.1574 20.7513 16.5149 20.5181C16.8724 20.285 16.9764 19.8079 16.7484 19.4471C15.6494 17.7554 14.0329 16.4645 12.14 15.7669ZM4.60098 10.895C4.60098 8.52346 6.52351 6.60093 8.89507 6.60093C11.2666 6.60093 13.1892 8.52346 13.1892 10.895C13.1892 13.2666 11.2666 15.1891 8.89507 15.1891C6.52463 15.1864 4.60367 13.2655 4.60098 10.895ZM25.1092 20.5274C24.748 20.7629 24.2644 20.6611 24.0288 20.3C22.5901 18.0833 20.1259 16.7471 17.4832 16.7506C17.0521 16.7506 16.7025 16.401 16.7025 15.9698C16.7025 15.5387 17.0521 15.1891 17.4832 15.1891C19.2127 15.1875 20.7723 14.1485 21.4402 12.5533C22.108 10.958 21.7537 9.11783 20.5413 7.88459C19.3289 6.65135 17.495 6.26578 15.8886 6.90639C15.6278 7.01911 15.3265 6.98132 15.1016 6.80771C14.8768 6.63411 14.764 6.35209 14.8071 6.07132C14.8502 5.79055 15.0423 5.55534 15.3089 5.45714C18.0932 4.34673 21.2664 5.5183 22.6611 8.1716C24.0559 10.8249 23.2216 14.103 20.7282 15.7669C22.621 16.4645 24.2376 17.7554 25.3365 19.4471C25.572 19.8082 25.4702 20.2919 25.1092 20.5274Z" fill="#ABABAB"/>
        </g>
        <defs>
        <clipPath id="clip0_54_20051">
        <rect width="24.9838" height="24.9838" fill="white" transform="translate(0.697266 0.35498)"/>
        </clipPath>
        </defs>
        </svg>
      ),
      title: "Health Insurance",
    },
    {
      id: 3,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
        <g clipPath="url(#clip0_54_20058)">
        <path fillRule="evenodd" clipRule="evenodd" d="M15.5314 11.9514H13.9699V5.70544H14.7506C16.4754 5.70544 17.8736 7.10364 17.8736 8.82841C17.8736 9.2596 18.2232 9.60915 18.6544 9.60915C19.0856 9.60915 19.4351 9.2596 19.4351 8.82841C19.4324 6.24237 17.3367 4.14664 14.7506 4.14395H13.9699V2.58246C13.9699 2.15127 13.6204 1.80172 13.1892 1.80172C12.758 1.80172 12.4084 2.15127 12.4084 2.58246V4.14395H11.6277C9.04052 4.14395 6.94321 6.24126 6.94321 8.82841C6.94321 11.4156 9.04052 13.5129 11.6277 13.5129H12.4084V19.7588H10.8469C9.12216 19.7588 7.72396 18.3606 7.72396 16.6358C7.72396 16.2047 7.37441 15.8551 6.94321 15.8551C6.51202 15.8551 6.16247 16.2047 6.16247 16.6358C6.16516 19.2219 8.26089 21.3176 10.8469 21.3203H12.4084V22.8818C12.4084 23.313 12.758 23.6625 13.1892 23.6625C13.6204 23.6625 13.9699 23.313 13.9699 22.8818V21.3203H15.5314C18.1185 21.3203 20.2159 19.223 20.2159 16.6358C20.2159 14.0487 18.1185 11.9514 15.5314 11.9514ZM11.6277 11.9514C9.9029 11.9514 8.5047 10.5532 8.5047 8.82841C8.5047 7.10364 9.9029 5.70544 11.6277 5.70544H12.4084V11.9514H11.6277ZM15.5314 19.7588H13.9699V13.5129H15.5314C17.2562 13.5129 18.6544 14.9111 18.6544 16.6358C18.6544 18.3606 17.2562 19.7588 15.5314 19.7588Z" fill="#ABABAB"/>
        </g>
        <defs>
        <clipPath id="clip0_54_20058">
        <rect width="24.9838" height="24.9838" fill="white" transform="translate(0.697266 0.240234)"/>
        </clipPath>
        </defs>
        </svg>
      ),
      title: "Work with cutting-edge agri-tech solutions",
    },
    {
      id: 4,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
        <g clipPath="url(#clip0_54_20065)">
        <path fillRule="evenodd" clipRule="evenodd" d="M18.0688 3.24895C16.0535 3.24895 14.289 4.11558 13.1892 5.58044C12.0893 4.11558 10.3248 3.24895 8.30951 3.24895C4.96933 3.25271 2.26252 5.95953 2.25875 9.29971C2.25875 16.1312 12.3879 21.6608 12.8193 21.8892C13.0502 22.0134 13.3281 22.0134 13.559 21.8892C13.9904 21.6608 24.1196 16.1312 24.1196 9.29971C24.1158 5.95953 21.409 3.25271 18.0688 3.24895ZM13.1892 20.3082C11.4071 19.2698 3.82024 14.5395 3.82024 9.29971C3.82347 6.82169 5.83149 4.81366 8.30951 4.81044C10.2077 4.81044 11.8014 5.8215 12.467 7.44545C12.5873 7.73832 12.8725 7.92953 13.1892 7.92953C13.5058 7.92953 13.791 7.73832 13.9113 7.44545C14.5769 5.81857 16.1706 4.81044 18.0688 4.81044C20.5468 4.81366 22.5549 6.82169 22.5581 9.29971C22.5581 14.5317 14.9693 19.2688 13.1892 20.3082Z" fill="#ABABAB"/>
        </g>
        <defs>
        <clipPath id="clip0_54_20065">
        <rect width="24.9838" height="24.9838" fill="white" transform="translate(0.697266 0.125977)"/>
        </clipPath>
        </defs>
        </svg>
        ),
      title: "Wellness Programs",
    },
    {
      id: 5,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25" fill="none">
        <g clipPath="url(#clip0_54_20073)">
        <path fillRule="evenodd" clipRule="evenodd" d="M20.9966 3.13469H18.6544V2.35395C18.6544 1.92276 18.3048 1.57321 17.8736 1.57321C17.4424 1.57321 17.0929 1.92276 17.0929 2.35395V3.13469H9.28544V2.35395C9.28544 1.92276 8.93589 1.57321 8.5047 1.57321C8.07351 1.57321 7.72396 1.92276 7.72396 2.35395V3.13469H5.38173C4.51934 3.13469 3.82024 3.83379 3.82024 4.69618V20.311C3.82024 21.1734 4.51934 21.8725 5.38173 21.8725H20.9966C21.859 21.8725 22.5581 21.1734 22.5581 20.311V4.69618C22.5581 3.83379 21.859 3.13469 20.9966 3.13469ZM7.72396 4.69618V5.47692C7.72396 5.90812 8.07351 6.25767 8.5047 6.25767C8.93589 6.25767 9.28544 5.90812 9.28544 5.47692V4.69618H17.0929V5.47692C17.0929 5.90812 17.4424 6.25767 17.8736 6.25767C18.3048 6.25767 18.6544 5.90812 18.6544 5.47692V4.69618H20.9966V7.81915H5.38173V4.69618H7.72396ZM20.9966 20.311H5.38173V9.38064H20.9966V20.311ZM11.6277 11.7229V17.9688C11.6277 18.4 11.2781 18.7496 10.8469 18.7496C10.4157 18.7496 10.0662 18.4 10.0662 17.9688V12.9857L9.63483 13.2024C9.24891 13.3953 8.77964 13.2389 8.58668 12.853C8.39372 12.4671 8.55014 11.9978 8.93606 11.8048L10.4975 11.0241C10.7397 10.903 11.0273 10.9159 11.2575 11.0583C11.4878 11.2006 11.6279 11.4521 11.6277 11.7229ZM17.4013 14.6946L15.5314 17.1881H17.0929C17.5241 17.1881 17.8736 17.5376 17.8736 17.9688C17.8736 18.4 17.5241 18.7496 17.0929 18.7496H13.9699C13.6742 18.7496 13.4038 18.5825 13.2716 18.318C13.1393 18.0535 13.1679 17.7369 13.3453 17.5004L16.154 13.7557C16.3281 13.524 16.3595 13.2149 16.2355 12.9529C16.1115 12.6909 15.8526 12.5191 15.5631 12.5068C15.2735 12.4944 15.0009 12.6435 14.8551 12.894C14.7196 13.1434 14.4595 13.2997 14.1757 13.3021C13.8918 13.3046 13.629 13.1528 13.4893 12.9057C13.3496 12.6586 13.355 12.3552 13.5034 12.1132C14.0337 11.1956 15.114 10.7484 16.1377 11.0227C17.1613 11.2971 17.8733 12.2246 17.8736 13.2844C17.8753 13.7935 17.7093 14.2891 17.4013 14.6946Z" fill="#ABABAB"/>
        </g>
        <defs>
        <clipPath id="clip0_54_20073">
        <rect width="24.9838" height="24.9838" fill="white" transform="translate(0.697266 0.0117188)"/>
        </clipPath>
        </defs>
        </svg>
      ),
      title: "Flexible work arrangements",
    },
    {
      id: 6,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
        <g clipPath="url(#clip0_54_20080)">
        <path fillRule="evenodd" clipRule="evenodd" d="M21.7773 6.36266H17.8736V5.58192C17.8736 4.28834 16.825 3.23969 15.5314 3.23969H10.8469C9.55335 3.23969 8.5047 4.28834 8.5047 5.58192V6.36266H4.60098C3.7386 6.36266 3.0395 7.06177 3.0395 7.92415V20.416C3.0395 21.2784 3.7386 21.9775 4.60098 21.9775H21.7773C22.6397 21.9775 23.3388 21.2784 23.3388 20.416V7.92415C23.3388 7.06177 22.6397 6.36266 21.7773 6.36266ZM10.0662 5.58192C10.0662 5.15073 10.4157 4.80118 10.8469 4.80118H15.5314C15.9626 4.80118 16.3121 5.15073 16.3121 5.58192V6.36266H10.0662V5.58192ZM21.7773 7.92415V11.985C19.1421 13.4194 16.1895 14.1706 13.1892 14.1701C10.189 14.1706 7.2364 13.4198 4.60098 11.986V7.92415H21.7773ZM21.7773 20.416H4.60098V13.7446C7.27496 15.0525 10.2124 15.7322 13.1892 15.7316C16.1659 15.7316 19.1034 15.0517 21.7773 13.7436V20.416ZM10.8469 11.8279C10.8469 11.3967 11.1965 11.0471 11.6277 11.0471H14.7506C15.1818 11.0471 15.5314 11.3967 15.5314 11.8279C15.5314 12.2591 15.1818 12.6086 14.7506 12.6086H11.6277C11.1965 12.6086 10.8469 12.2591 10.8469 11.8279Z" fill="#ABABAB"/>
        </g>
        <defs>
        <clipPath id="clip0_54_20080">
        <rect width="24.9838" height="24.9838" fill="white" transform="translate(0.697266 0.897461)"/>
        </clipPath>
        </defs>
        </svg>
        ),
      title: "Career Growth",
    },
    {
      id: 7,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
        <g clipPath="url(#clip0_54_20065)">
        <path fillRule="evenodd" clipRule="evenodd" d="M18.0688 3.24895C16.0535 3.24895 14.289 4.11558 13.1892 5.58044C12.0893 4.11558 10.3248 3.24895 8.30951 3.24895C4.96933 3.25271 2.26252 5.95953 2.25875 9.29971C2.25875 16.1312 12.3879 21.6608 12.8193 21.8892C13.0502 22.0134 13.3281 22.0134 13.559 21.8892C13.9904 21.6608 24.1196 16.1312 24.1196 9.29971C24.1158 5.95953 21.409 3.25271 18.0688 3.24895ZM13.1892 20.3082C11.4071 19.2698 3.82024 14.5395 3.82024 9.29971C3.82347 6.82169 5.83149 4.81366 8.30951 4.81044C10.2077 4.81044 11.8014 5.8215 12.467 7.44545C12.5873 7.73832 12.8725 7.92953 13.1892 7.92953C13.5058 7.92953 13.791 7.73832 13.9113 7.44545C14.5769 5.81857 16.1706 4.81044 18.0688 4.81044C20.5468 4.81366 22.5549 6.82169 22.5581 9.29971C22.5581 14.5317 14.9693 19.2688 13.1892 20.3082Z" fill="#ABABAB"/>
        </g>
        <defs>
        <clipPath id="clip0_54_20065">
        <rect width="24.9838" height="24.9838" fill="white" transform="translate(0.697266 0.125977)"/>
        </clipPath>
        </defs>
        </svg>
      ),
      title: "Supportive and collaborative work culture",
    }
  ];

  return (
    <section ref={sectionRef} className="w-full bg-white pb-[60px] md:pt-[100px] md:py-[144px] overflow-hidden">
      <div className="max-w-[1278px] mx-auto px-4 md:px-[20px] lg:px-8 flex flex-col gap-6">
        {/* Main heading and description */}
        <div className="mb-0 md:mb-2">
          <h2 
            ref={headingRef}
            className="font-[LTWave] font-medium text-3xl md:text-4xl lg:text-[44px] leading-[150%] capitalize mb-2 md:mb-4 will-change-transform"
          >
            Benefits
          </h2>
          <p 
            ref={paragraphRef}
            className="font-inter font-normal text-base md:text-lg lg:text-[18px] leading-[150%] max-w-[1200px] opacity-50 text-[#1C1C1C] will-change-transform"
          >
            At Agstya Agriculture, we believe in growing together. You'll work in an environment that values innovation, sustainability, and community impact. 
            We offer competitive salaries, professional development opportunities, flexible work culture, and the chance to make a real difference in the 
            agricultural sector.
          </p>
        </div>

        {/* Benefits grid - height: 166.55px */}
        <div className="flex flex-col gap-[12.49px]">
          {/* First row */}
          <div ref={firstRowRef} className="flex flex-col md:flex-row gap-[12.49px]">
            <div className="benefit-card w-full md:w-[310px] h-[77px] bg-gray-50 rounded-[12px] border border-gray-200 p-[16.66px] flex items-center gap-[12.49px] transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 hover:border-gray-300 will-change-transform">
              <div className="text-2xl transition-transform duration-300 ease-in-out group-hover:scale-105">{benefitsList[0].icon}</div>
              <span className="font-inter w-full max-w-[110px] text-base font-medium text-[#ABABAB]">{benefitsList[0].title}</span>
            </div>
            
            <div className="benefit-card w-full md:w-[310px] h-[77px] bg-gray-50 rounded-[12px] border border-gray-200 p-[16.66px] flex items-center gap-[12.49px] transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 hover:border-gray-300 will-change-transform">
              <div className="text-2xl transition-transform duration-300 ease-in-out group-hover:scale-105">{benefitsList[1].icon}</div>
              <span className="font-inter w-full max-w-[110px] text-base font-medium text-[#ABABAB]">{benefitsList[1].title}</span>
            </div>
            
            <div className="benefit-card w-full md:w-[417px] h-[77px] bg-gray-50 rounded-[12px] border border-gray-200 p-[16.66px] flex items-center gap-[12.49px] transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 hover:border-gray-300 will-change-transform">
              <div className="text-2xl transition-transform duration-300 ease-in-out group-hover:scale-105">{benefitsList[2].icon}</div>
              <span className="font-inter text-base font-medium text-[#ABABAB]">{benefitsList[2].title}</span>
            </div>

            <div className="benefit-card w-full md:w-[310px] h-[77px] bg-gray-50 rounded-[12px] border border-gray-200 p-[16.66px] flex items-center gap-[12.49px] transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 hover:border-gray-300 will-change-transform">
              <div className="text-2xl transition-transform duration-300 ease-in-out group-hover:scale-105">{benefitsList[3].icon}</div>
              <span className="font-inter w-full max-w-[110px] text-base font-medium text-[#ABABAB]">{benefitsList[3].title}</span>
            </div>
          </div>
          
          {/* Second row */}
          <div ref={secondRowRef} className="flex flex-col md:flex-row gap-[12.49px]">
            <div className="benefit-card w-full md:w-[417px] h-[77px] bg-gray-50 rounded-[12px] border border-gray-200 p-[16.66px] flex items-center gap-[12.49px] transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 hover:border-gray-300 will-change-transform">
              <div className="text-2xl transition-transform duration-300 ease-in-out group-hover:scale-105">{benefitsList[4].icon}</div>
              <span className="font-inter text-base font-medium w-full max-w-[110px] text-[#ABABAB]">{benefitsList[4].title}</span>
            </div>
            
            <div className="benefit-card w-full md:w-[417px] h-[77px] bg-gray-50 rounded-[12px] border border-gray-200 p-[16.66px] flex items-center gap-[12.49px] transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 hover:border-gray-300 will-change-transform">
              <div className="text-2xl transition-transform duration-300 ease-in-out group-hover:scale-105">{benefitsList[5].icon}</div>
              <span className="font-inter text-base font-medium w-full max-w-[110px] text-[#ABABAB]">{benefitsList[5].title}</span>
            </div>
            
            <div className="benefit-card w-full md:w-[417px] h-[77px] bg-gray-50 rounded-[12px] border border-gray-200 p-[16.66px] flex items-center gap-[12.49px] transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 hover:border-gray-300 will-change-transform">
              <div className="text-2xl transition-transform duration-300 ease-in-out group-hover:scale-105">{benefitsList[6].icon}</div>
              <span className="font-inter text-base font-medium w-full max-w-[265px] text-[#ABABAB]">{benefitsList[6].title}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
